//import Drawer from 'components/Drawer'
import Loader from 'components/Loader'
import TopLevelModals from 'components/TopLevelModals'
import { Suspense, useEffect } from 'react'
import { Route, Switch, useHistory, useLocation } from 'react-router-dom'
import styled from 'styled-components/macro'

import { useAnalyticsReporter } from '../components/analytics'
import ErrorBoundary from '../components/ErrorBoundary'
import Header from '../components/Header'
import Polling from '../components/Header/Polling'
import Popups from '../components/Popups'
import DarkModeQueryParamReader from '../theme/DarkModeQueryParamReader'
import Chips from './Chips'
import Dice from './Dice'
import Home from './Home'
import { RedirectPathToToHome } from './Home/redirects'
import Referrals from './Referrals'
import ReferralGetter from './Referrals/getter'
import Roulette from './Roulette'
import Sport from './Sport'
import Stake from './Stake'

const AppWrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
`

const PageWrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 120px 16px 0px 16px;
`
const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 120px 16px 0px 16px;
  align-items: center;
  flex: 1;
  z-index: 1;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    padding: 4rem 8px 16px 8px;
  `};
`

const HeaderWrapper = styled.div`
  ${({ theme }) => theme.flexRowNoWrap}
  width: 100%;
  justify-content: space-between;
  position: fixed;
  top: 0;
  z-index: 2;
`

const Marginer = styled.div`
  margin-top: 5rem;
`

export default function App() {
  const history = useHistory()
  useAnalyticsReporter(useLocation())

  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0)
    })
    return () => {
      unlisten()
    }
  }, [history])

  return (
    <ErrorBoundary>
      <Route component={DarkModeQueryParamReader} />
      <Route component={ReferralGetter} />
      <AppWrapper>
        <HeaderWrapper>
          <Header />
        </HeaderWrapper>

        {/* <PageWrapper>
          <Sidebar /> */}
        <BodyWrapper>
          <Popups />
          <Polling />
          <TopLevelModals />
          <Suspense fallback={<Loader />}>
            <Switch>
              <Route exact strict path="/home" component={Home} />
              <Route exact strict path="/stake" component={Stake} />
              <Route exact strict path="/referrals" component={Referrals} />
              <Route exact strict path="/chips" component={Chips} />
              <Route exact strict path="/dice" component={Dice} />
              <Route exact strict path="/roulette" component={Roulette} />
              <Route exact strict path="/sport" component={Sport} />

              <Route component={RedirectPathToToHome} />
            </Switch>
          </Suspense>
          <Marginer />
        </BodyWrapper>
        {/*   </PageWrapper> */}
      </AppWrapper>
    </ErrorBoundary>
  )
}
